module.exports = "https://de18y2hs3hlxs.cloudfront.net/d7023bab-6786-4218-a639-f7331314cecc/images/notepad.png?75405c954d83b33e90b18b75fbe7ed89";